export default __webpack_public_path__ + "static/media/cough.6ba8ae40.svg";